const env = {
  API_BASE_URL: process.env.NEXT_PUBLIC_API_URL || '',
  SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN || '',
  SENTRY_ENVIRONMENT: process.env.SENTRY_ENVIRONMENT || '',
  SENTRY_TRACES_SAMPLE_RATE: process.env.SENTRY_TRACES_SAMPLE_RATE || '1',
  SENTRY_DEBUG: process.env.SENTRY_DEBUG || 'false',
  RECAPTCHA_V3_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_V3_SITE_KEY || '',
  RECAPTCHA_V2_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_V2_SITE_KEY || '',
};

export default env; 